import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IBumerangue } from "../types/types";

// import { Container } from './styles';

interface Props {
  data?: IBumerangue;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  const terminalName =
    props.data?.terminal?.razao_social || props.data?.terminal?.nome_fantasia;

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-1 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_bumerangue !== undefined && props.data?.id_bumerangue !== null
                ? String(props.data.id_bumerangue)
                : "---"}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Terminal</span>
            <span className="text-sm text-[#666666] font-normal">
              {terminalName ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Intervalo em dias</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.intervalo_dias !== undefined && props.data?.intervalo_dias !== null
                ? String(props.data.intervalo_dias)
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">ID do Terminal</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_terminal !== undefined && props.data?.id_terminal !== null
                ? String(props.data.id_terminal)
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data Modificação</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Usuário</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
